export const ADMIN_SIGNUP_CODE =
  process.env.REACT_APP_ADMIN_SIGNUP_CODE || 'ADMIN2026';
